/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : CTA : CREATE EMBED : STYLES --------------- ++++++++++ */
export default theme => ({
	createEmbed: {
		'& .loader': {
			display: 'none',
			fontSize: '65%',
			marginRight: pxToEm(10)
			// marginTop: pxToEm(-20)
		},
		'&.state-creating-true': {
			'& .loader': {
				display: 'inline-block'
			}
		}
	}
});
